<template>
  <div class="zw-product-five-template">
    <!--    背景图-->
    <div
      :style="{backgroundImage:'url('+ bgImgUrl +')'}"
      class="zw-five-bg"
    >
      <div class="zw-five-bg-tile">
        <div>人事工资综合管理系统</div>
        <span>工资自动套算，人资管理更高效</span>
      </div>
    </div>
    <div class="zw-five-bg-introduc">
      <div
        style="display: flex;justify-content: center;
      flex-direction: column;align-items: center;margin-bottom: 20px"
      >
        <img src="../../assets/image/product/xtjs.png" alt="">
        <div
          style="font-size: 28px;margin-top: -20px;
        font-weight: bold;color: #000000;"
        >系统简介</div>
        <span style="border: 3px solid #00c7c5;width: 80px;margin-top: 20px" />
      </div>
      <div style="display: flex;padding: 50px 0;width: 100%;justify-content: center">
        <div style="">
          <img src="../../assets/image/product/xtwj.png" width="450" alt="">
        </div>
        <div
          style="display: flex;flex-direction: column;
        justify-content: space-between;width: 40%;min-width: 450px; "
        >
          <div
            style="font-size: 16px;color: #000000;
        line-height: 26px"
          >
            人事工资综合管理系统是服务于机关事业单位，通过深入领会国家人事工资制度改革以及业务政策，形成的一套覆盖行政、
            事业单位人事工资变动过程全流程、全业务的协同办公、综合管理应用软件平台。实现了流程化的审批、管理，不仅提高了
            工作效率，减轻了工作压力，更加使人事工资管理工作规范化、信息化、自动化。同时系统安装灵活方便又兼顾地方特色，
            可适应于各级的工资管理工作，实现了人事与工资管理的科学、准确、高效。
          </div>
          <div style="display: flex;justify-content: right;width: 100%">
            <el-divider />
            <div style="border: 3px solid #00c7c5;width: 80px;margin-top: -2px" />
          </div>
        </div>
      </div>
    </div>
    <div class="zw-five-bg-trait">
      <div
        style="display: flex;justify-content: center;
      flex-direction: column;align-items: center;margin-bottom: 20px"
      >
        <img src="../../assets/image/product/xtjs.png" alt="">
        <div
          style="font-size: 28px;margin-top: -20px;
        font-weight: bold;color: #000000;"
        >系统特点</div>
        <span style="border: 3px solid #00c7c5;width: 80px;margin-top: 20px" />
      </div>
      <div class="zw-trait-context">
        <ul>
          <li v-for="(item, index) in traitList" :key="index">
            <div>
              <img :src="item.imgUrl" alt="">
            </div>
            <div style="text-align: center;color: #000000">
              {{ item.text }}
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!--免费获取方案-->
    <div
      :style="{backgroundImage:'url('+ fontImg +')'}"
      class="zw-five-footer"
    >
      <div
        style="display: flex;align-items: center;height: 100%;
      justify-content: center;flex-direction: column"
      >
        <div style="font-size: 28px;font-weight: bold;color: #000000;padding-bottom: 30px">
          即刻为你的企业定制解决方案
        </div>
        <el-button size="small" type="primary" @click="handleProgramme">免费获取方案</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PersonnelWage',
  data() {
    return {
      bgImgUrl: require('../../assets/image/product/fiveTemBg.jpg'),
      fontImg: require('../../assets/image/product/mfhqfa.jpg'),
      traitList: [
        {
          imgUrl: require('../../assets/image/product/five01.png'),
          text: '对工资项的计算公式提供自定义配置，自动套算工资；'
        },
        {
          imgUrl: require('../../assets/image/product/five02.png'),
          text: '完整保存工资变动历史记录并提供查询信息；'
        },
        {
          imgUrl: require('../../assets/image/product/five03.png'),
          text: '提供网络化的审批设置，可自定义设置审批流程；'
        },
        {
          imgUrl: require('../../assets/image/product/five04.png'),
          text: '科学的人员信息管理功能，保障人员信息的完整性和唯一性；'
        },
        {
          imgUrl: require('../../assets/image/product/five05.png'),
          text: '提供各类汇总统计表格，可自定义定制报表；'
        },
        {
          imgUrl: require('../../assets/image/product/five05.png'),
          text: '增人自动校验身份证，防止“吃空饷”情况发生。'
        }
      ]
    }
  },
  methods: {
    // 免费获取方案
    handleProgramme() {
      this.$router.push({
        path: '/getScheme'
      })
    }
  }
}
</script>

<style scoped>

</style>
